// extracted by mini-css-extract-plugin
module.exports = {"title":"_2szVXuKMovi3aYXTydzNZm","container":"_2TlZW3yR2SEII9TBSfsuLi"};